/**
 * Please find  chuhaashanan's score (40).
 */
(function () {
  'use strict';

  angular.module('adminCommanderDiscretion').controller('CmndDescretionPopupCtrl', CmndDescretionPopupCtrl);

  function CmndDescretionPopupCtrl(modalParams,$uibModalInstance,EventManagerService,AdminCommanderDiscretionService,MessageService) {
 
	var vm = this;

    vm.model = {
      remarkButtonClicked : false,		
      generalData : modalParams.generalData,
      partA : modalParams.reportData.commanderDiscretionReportPartARequest,
      partB : modalParams.reportData.commanderDiscretionReportPartBRequest,
      partC1 : modalParams.reportData.commanderDiscretionReportPartC1Request,
      partC2 : duplicateC2Items(modalParams.reportData.commanderDiscretionReportPartC2Request),
      partD : modalParams.reportData.commanderDiscretionReportPartDRequest,
      partE : modalParams.reportData.commanderDiscretionReportPartERequest,
      remarks : null
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
      vm.closeMe();
    }
    
    vm.onRemoarkClick = function () {
    	vm.model.remarkButtonClicked = !vm.model.remarkButtonClicked;
    }
    
    vm.onSaveRemark = function () {
    	 showLoader(true);
         AdminCommanderDiscretionService.saveAdminRemark(vm.model,
             function (response) {
        	 	if(response.success){
        	 		vm.model.partE = response.commanderDiscretionReportPartERequest;
        	 		vm.model.remarks = null;
        	 		vm.model.remarkButtonClicked = false;
        	 		MessageService.success('Successfully saved the record!');
        	 	}
        	 	showLoader(false);
             },
             function (error) {
                 MessageService.error(error);
                 showLoader(false);
             }
         );
    }
    
    vm.onReject = function () {
    	 showLoader(true);
         AdminCommanderDiscretionService.changeStatus("REJECTED",vm.model,
             function (response) {
        	 	if(response.success){
        	 		MessageService.success('Successfully saved the record!');
        	 	}
        	 	vm.closeMe();
        	 	showLoader(false);
             },
             function (error) {
                 MessageService.error(error);
                 showLoader(false);
             }
         );
    }
    
    vm.onApprove = function () {
    	 showLoader(true);
         AdminCommanderDiscretionService.changeStatus("APPROVED",vm.model,
             function (response) {
        	 	if(response.success){
        	 		MessageService.success('Successfully saved the record!');
        	 	}
        	 	showLoader(false);
        	 	vm.closeMe();
             },
             function (error) {
                 MessageService.error(error);
                 showLoader(false);
             }
         );
    }
    
    function showLoader(flag) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
            flag: flag,
            target: 'adminCommanderDiscretion',
            animationName: 'crewing-loader'
        });
    }
    
    function duplicateC2Items(items) {
    	var duplicateList = [];
    	var number = 1;
        angular.forEach(items, function (item) {
        	const obj1 = Object.assign({}, item);
        	obj1["number"]=number++;
        	const obj2 = Object.assign({}, item);
        	obj2["number"]=number++;
        	duplicateList.push(obj1);
        	duplicateList.push(obj2);
        });
       return duplicateList.sort(function(a, b) {
    	   return a.number - b.number;
       });
    }
    
    vm.closeMe = function() {
		$uibModalInstance.close();
	};
    
  }
}());
